<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :destroy-on-close="true"	
    :show-close="true"
    :center="true"
    @close="handleClose"
    title="薪资模版详情"
    width="700px"
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="140px">
       
        <el-form-item label="模版名称" prop="template_name" >  
          <el-input  type="text" v-model="formData.template_name" ></el-input> 
        </el-form-item>

        <el-form-item label="计薪方式" prop="rules_type" >
          <el-select v-model="formData.rules_type" placeholder="请选择">
            <el-option label="计件" :value="1"></el-option>
            <el-option label="计时" :value="2"></el-option>
            <el-option label="计件+计时" :value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="计件方式" prop="type" v-if="formData.rules_type==1||formData.rules_type==3">
          <el-select v-model="formData.type" placeholder="请选择" @change="changeType()">
            <el-option label="普通计算" :value="1"></el-option>
            <el-option label="阶梯计算" :value="2"></el-option>
          </el-select>
        </el-form-item>
 
        <el-form-item label="计件单价"  prop="piece_salary"   v-if="(formData.rules_type==1||formData.rules_type==3)&&formData.type==1" >
          <el-input type="number" v-model="formData.piece_salary"></el-input>
        </el-form-item>

        <el-form-item label="阶梯规则"  prop="rules"  v-if="(formData.rules_type==1||formData.rules_type==3)&&formData.type==2" >
          <el-row  v-for="(item, index) in formData.rules" :key="index">
                <el-col :span="6">
                    <el-form-item label="" :prop="'rules.' + index + '.start'"  :rules="rules.start" label-width="auto"	>
                        <el-input v-model="item.start" placeholder="开始数量"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="" :prop="'rules.' + index + '.end'"  :rules="rules.end"  label-width="auto"	>
                        <el-input v-model="item.end"  placeholder="结束数量"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="" :prop="'rules.' + index + '.price'"  :rules="rules.price"  label-width="auto"	>
                        <el-input v-model="item.price"  placeholder="单价"></el-input>
                    </el-form-item>
                </el-col>


                <el-col :span="6">
                  <el-button @click.prevent="removeComp(item)">删除</el-button>
                </el-col>
            </el-row>

            <el-button @click="addComponents">添加计件规则</el-button>
        </el-form-item>


        <el-form-item label="计时单价"  prop="unit_salary"  v-if="formData.rules_type==2||formData.rules_type==3">
          <el-input type="number" v-model="formData.unit_salary"></el-input>
        </el-form-item>

        <el-form-item label="计时单位" prop="unit" v-if="formData.rules_type==2||formData.rules_type==3">
          <el-select v-model="formData.unit" placeholder="请选择">
            <el-option label="日" :value="1"></el-option>
            <el-option label="小时" :value="2"></el-option>
            <el-option label="月" :value="3"></el-option>
            <el-option label="次" :value="4"></el-option>
            <el-option label="单" :value="5"></el-option>
          </el-select>
        </el-form-item>
        

        <el-form-item label="工资结算周期" prop="settle_method" >
          <el-select v-model="formData.settle_method" placeholder="请选择">
            <el-option label="日结" :value="1"></el-option>
            <el-option label="周结" :value="2"></el-option>
            <el-option label="月结" :value="3"></el-option>
            <el-option label="完工结" :value="4"></el-option>
          </el-select>
        </el-form-item>
        
    
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>

  </el-dialog>
</template>

<script>
import { addSalary,editSalary} from "@/api/director/project/index.js";

export default {
  props: {
    project_id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      formData: {
        template_id:"",
        template_name:"",
        rules_type:"",
        type: "",
        piece_salary: "",
        unit_salary: "",
        unit: "",
        settle_method: "",
        rules:[],
      },
       rules: {
        template_name: [
              {required: true, message: '请输入模版名称', trigger: 'change'}
          ],
          rules_type: [
              {required: true, message: '请选择计薪方式', trigger: 'change'}
          ],
          settle_method: [
              {required: true, message: '请选择工资结算周期', trigger: 'change'}
          ],
          
          piece_salary: [
              {required: true, message: '请选择计件每件价格', trigger: 'change'}
          ],
          rules: [
              {required: true, message: '请选择阶梯计件规则', trigger: 'change'}
          ],
          
          unit: [
              {required: true, message: '请选择计时工资单位', trigger: 'change'}
          ],

          unit_salary: [
              {required: true, message: '请选择计时工资单价', trigger: 'change'}
          ],
          start: [
              {required: true, message: '请填写阶梯计件开始数量', trigger: 'change'}
          ],
          end: [
              {required: true, message: '请填写阶梯计件结束数量', trigger: 'blur'}
          ],
          price: [
              {required: true, message: '请填写阶梯计件单价', trigger: 'blur'}
          ],
         
       }
    };
  },

 
  mounted() {
    console.log("asdasdasd")

},
  
  methods: {
    handleClose() {
      this.$refs["form"].resetFields();
      this.resetForm();
      this.visible = false;
    },

    init(data) {
      console.log(data)
      if(data){
        this.formData.template_id=data.template_id;
        this.formData.template_name=data.template_name;
        this.formData.rules_type=data.rules_type;
        this.formData.type=data.type;
        this.formData.piece_salary=data.piece_salary;
        this.formData.unit_salary=data.unit_salary;
        this.formData.unit=data.unit;
        this.formData.settle_method=data.settle_method;
        this.formData.rules=data.rules;

      }else{
        this.resetForm();
      }
     
      this.visible = true;
    },


    addComponents(){
      this.formData.rules.push({
                start: null,
                end: null,
                price: "",
        })
    },

    removeComp(item){
      var index = this.formData.rules.indexOf(item)
      if (index !== -1) {
        this.formData.rules.splice(index, 1)
      }
    },

    changeType(e){
      console.log(e);

    },

    resetForm(){
      this.formData= {
        template_id:"",
        template_name:"",
        rules_type:"",
        type: "",
        piece_salary: "",
        unit_salary: "",
        unit: "",
        settle_method: "",
        rules:[],
      }
    },

    
    
    submit(){
      var that=this;
      that.formData.project_id=this.project_id;

      this.$refs["form"].validate((valid) => {
          if (valid) {
            if(that.formData.template_id){
              editSalary(that.formData).then((response) => {
                console.log(response);
                if(response.code==200){
                  this.$message({
                    message: "提交成功",
                    type: 'success'

                  });
                  that.$emit('refresh');
                  that.visible = false;
                
                }else{
                  this.$message({
                    message: response.msg?response.msg:"提交失败",
                  });
                }
              });
            }else{
              addSalary(that.formData).then((response) => {
                console.log(response);
                if(response.code==200){
                  this.$message({
                    message: "提交成功",
                    type: 'success'

                  });
                  that.$emit('refresh');
                  that.visible = false;
                
                }else{
                  this.$message({
                    message: response.msg?response.msg:"提交失败",
                  });
                }
              });
            }
            
          } 
        });
    },

    
  },

 
};
</script>

<style lang="scss" scoped>



::v-deep .myWindow {
    border-radius: 15px;



/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
